/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { MCPSetupGuide, MCPSetupGuide$inboundSchema } from "./mcpsetupguide.js";

export type GetSetupDocsResponseBody = {
  /**
   * Matching setup guides, most specific match first. Empty when no guide has been published for the server.
   */
  guides: Array<MCPSetupGuide>;
};

/** @internal */
export const GetSetupDocsResponseBody$inboundSchema: z.ZodMiniType<
  GetSetupDocsResponseBody,
  unknown
> = z.object({
  guides: z.array(MCPSetupGuide$inboundSchema),
});

export function getSetupDocsResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<GetSetupDocsResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetSetupDocsResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetSetupDocsResponseBody' from JSON`,
  );
}
